












import {Vue, Component} from 'vue-property-decorator'
import getConnection from "@/utils/signalr_connection";
import {loadedGoogleMapsAPI} from "@/plugins/maps.plugin";
declare const google: any;

@Component({})
export default class ActiveVisitsMap extends Vue {
  mapCenter = {lat: 45.262231, lng: 19.8518579};
  zoom = 8;
  map;
  markers = [];

  created() {
    getConnection().on('visitsChanged', this.getVisits);
  }

  async mounted() {
    loadedGoogleMapsAPI.then(() => {
      this.map = new google.maps.Map(document.getElementById('map'), {
        center: this.mapCenter,
        mapTypeControl: false,
        zoom: this.zoom
      });
    });
    await this.getVisits();
  }

  async getVisits() {
    const { data } = await this.$http.get('/api/GetActiveVisits');
    let bounds = new google.maps.LatLngBounds();

    for (let i = 0; i < this.markers.length; i++) {
      let marker = this.markers[i];
      marker.setMap(null);
    }
    this.markers = [];

    for (let i = 0; i < data.length; i++) {
      let visit = data[i];
      if (!visit.latitude || !visit.longitude) continue;
      let position = new google.maps.LatLng(visit.latitude, visit.longitude);
      bounds.extend(position);
      let marker = new google.maps.Marker({
        map: this.map,
        position: position,
        title: visit.storeName,
      });
      this.markers.push(marker);
      this.map.fitBounds(bounds);
      this.map.panToBounds(bounds);
    }
  }

  destroyed() {
    getConnection().on('visitsChanged', this.getVisits);
  }
}
